/**
 * Check if user is logged into a specific program
 * @param {number} programId - The program ID to check
 * @returns {boolean} - True if user is logged in, false otherwise
 */
export const checkUserLoginForProgram = (programId) => {
  try {
    switch (programId) {
      case 1: // NCD
        return !!localStorage.getItem("NCD_token");
      case 2: // SCD/Sickle
        return !!localStorage.getItem("sickle_token");
      case 4: // Nikshay
        return !!localStorage.getItem("NIKSHAY_valid_user");
      case 5: // Janani
        return !!localStorage.getItem("JANANI_token");
      case 6: // UWIN
        return !!localStorage.getItem("uwin_token");
      case 8: //PMNDP
       //return !!localStorage.getItem("PMNDP_token");
        return true;
      case 11: // RBSK
        return !!localStorage.getItem("RBSK_token");
      default:
        return false;
    }
  } catch (error) {
    console.error("Error checking user login:", error);
    return false;
  }
};

/**
 * Get program name by ID
 * @param {number} programId - The program ID
 * @returns {string} - Program name
 */
export const getProgramName = (programId) => {
  const programNames = {
    1: "NCD",
    2: "SATH",
    4: "Nikshay", 
    5: "JANANI", 
    6: "UWIN",
    8: "PMNDP",
    11: "RBSK"
  };
  return programNames[programId] || "Unknown Program";
};